import React from "react";
import {Route, Switch} from "react-router-dom";
import RequestPasswordResetLayout from "./layouts/RequestPasswordResetLayout/RequestPasswordResetLayout";
import ResetPasswordCompleteLayout from "./layouts/ResetPasswordCompleteLayout/ResetPasswordCompleteLayout";
import ResetPasswordLayout from "./layouts/ResetPasswordLayout/ResetPasswordLayout";
import AccountLockedLayout from "./layouts/AccountLockedLayout/AccountLockedLayout";

const PasswordResetRoutes = (parentProps) => (
    <Switch>
        <Route
            exact
            path={`${parentProps.match.url}/user/:userId/token/:token`}
            render={(props) => <ResetPasswordLayout {...parentProps} {...props} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}/applicant/:userId/token/:token`}
            render={(props) => <ResetPasswordLayout isApplicant {...parentProps} {...props} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}/applicant/complete`}
            render={(props) => <ResetPasswordCompleteLayout {...parentProps} {...props} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}/complete`}
            render={(props) => <ResetPasswordCompleteLayout {...parentProps} {...props} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}/accountlocked`}
            render={(props) => <AccountLockedLayout {...props} {...parentProps} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}/request`}
            render={(props) => <RequestPasswordResetLayout {...props} {...parentProps} />}
        />
        <Route
            exact
            path={`${parentProps.match.url}`}
            render={(props) => <RequestPasswordResetLayout {...props} {...parentProps} />}
        />
    </Switch>
);

export default PasswordResetRoutes;
